module.exports = __webpack_public_path__ + "img/attach.807ca2d2.svg";